import { Link } from 'react-router-dom';
import { ArrowRight, Drill, Wrench, Package, HardHat, Hammer, Ship, Truck, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const ServicesPage = () => {
  const services = [
    {
      id: 'oil-gas',
      icon: <Drill className="w-10 h-10" />,
      title: 'Oil & Gas Services',
      description: 'Comprehensive oilfield services including well maintenance, intervention, and support operations.',
      features: [
        'Wellhead maintenance and repair',
        'Slickline and E-line services',
        'BHP surveys and analysis',
        'Coil tubing operations',
        'Workover and completion services',
        'Well testing and monitoring',
      ],
      image: 'https://images.unsplash.com/photo-1758797849151-1725021be42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxvaWwlMjBhbmQlMjBnYXMlMjBvZmZzaG9yZSUyMHBsYXRmb3JtJTIwb2NlYW58ZW58MHx8fHwxNzczODU0ODMwfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'mechanical',
      icon: <Wrench className="w-10 h-10" />,
      title: 'Mechanical & Engineering',
      description: 'Expert mechanical services for industrial facilities and infrastructure projects.',
      features: [
        'Pipeline construction and replacement',
        'Pump installation and maintenance',
        'Tank and vessel testing',
        'Pressure vessel inspection',
        'Industrial equipment maintenance',
        'Fabrication and welding services',
      ],
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZW5naW5lZXJpbmclMjBjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBzYWZldHklMjBoZWxtZXR8ZW58MHx8fHwxNzczODU0ODMxfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'procurement',
      icon: <Package className="w-10 h-10" />,
      title: 'Procurement Services',
      description: 'Reliable procurement and supply chain solutions for the oil & gas industry.',
      features: [
        'Supply of compressors and pumps',
        'Spare parts procurement',
        'Equipment sourcing globally',
        'Installation support',
        'Vendor management',
        'Quality assurance inspection',
      ],
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&auto=format&fit=crop&q=60',
    },
    {
      id: 'drilling',
      icon: <HardHat className="w-10 h-10" />,
      title: 'Drilling Services',
      description: 'Advanced drilling solutions including directional drilling and rig services.',
      features: [
        'Directional drilling',
        'Rig supply and accessories',
        'Field development services',
        'Drilling fluids management',
        'Mud engineering',
        'Drilling optimization',
      ],
      image: 'https://images.unsplash.com/photo-1770099172083-724c91d9ccf6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxvaWwlMjBhbmQlMjBnYXMlMjBvZmZzaG9yZSUyMHBsYXRmb3JtJTIwb2NlYW58ZW58MHx8fHwxNzczODU0ODMwfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'civil',
      icon: <Hammer className="w-10 h-10" />,
      title: 'Civil & Construction',
      description: 'Complete civil engineering and construction services for industrial projects.',
      features: [
        'Steel structures fabrication',
        'Tank farm construction',
        'Road and bridge construction',
        'Piling works',
        'Building construction',
        'Infrastructure development',
      ],
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&auto=format&fit=crop&q=60',
    },
    {
      id: 'marine',
      icon: <Ship className="w-10 h-10" />,
      title: 'Marine & Logistics',
      description: 'Comprehensive marine and logistics solutions for offshore operations.',
      features: [
        'Tug boat services',
        'Barge transportation',
        'Marine transport services',
        'Bulk haulage',
        'Offshore logistics support',
        'Port operations',
      ],
      image: 'https://images.unsplash.com/photo-1765048639586-8f3c3ed36a04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxvaWwlMjBhbmQlMjBnYXMlMjBvZmZzaG9yZSUyMHBsYXRmb3JtJTIwb2NlYW58ZW58MHx8fHwxNzczODU0ODMwfDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'equipment',
      icon: <Truck className="w-10 h-10" />,
      title: 'Equipment Rentals',
      description: 'Wide range of industrial equipment available for rent.',
      features: [
        'Cranes and lifting equipment',
        'Bulldozers and excavators',
        'Compressors',
        'Vacuum trucks',
        'Welding machines',
        'Power generators',
      ],
      image: 'https://images.unsplash.com/photo-1580901368919-7738efb0f87e?w=800&auto=format&fit=crop&q=60',
    },
  ];

  return (
    <div data-testid="services-page">
      {/* Hero Section */}
      <section className="pt-32 pb-20 md:pt-40 md:pb-32 bg-[#0A0A0A] relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF6B00' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-2 bg-[#FF6B00] text-white text-xs uppercase tracking-widest font-bold mb-6">
              Our Services
            </span>
            <h1 className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold text-white uppercase leading-tight tracking-tight mb-6">
              Comprehensive Engineering Solutions
            </h1>
            <p className="text-lg text-slate-400 leading-relaxed">
              From wellhead maintenance to large-scale construction, we deliver integrated services that meet the demanding standards of the oil & gas industry.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-24">
            {services.map((service, index) => (
              <div 
                key={service.id}
                id={service.id}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
                data-testid={`service-section-${service.id}`}
              >
                {/* Image */}
                <div className={`relative ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="aspect-[4/3] bg-slate-200 overflow-hidden">
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute -bottom-4 -right-4 bg-[#FF6B00] p-4 hidden md:block">
                    <span className="text-white">{service.icon}</span>
                  </div>
                </div>

                {/* Content */}
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="text-[#FF6B00] mb-4 md:hidden">
                    {service.icon}
                  </div>
                  <h2 className="font-['Barlow_Condensed'] text-2xl md:text-4xl font-bold text-[#0A0A0A] uppercase tracking-tight mb-4">
                    {service.title}
                  </h2>
                  <p className="text-slate-600 text-lg leading-relaxed mb-8">
                    {service.description}
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                    {service.features.map((feature, fIndex) => (
                      <li key={fIndex} className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" />
                        <span className="text-slate-700 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact">
                    <Button 
                      data-testid={`service-cta-${service.id}`}
                      className="bg-[#0A0A0A] text-white hover:bg-[#FF6B00] rounded-none uppercase tracking-wider font-bold px-8 py-5"
                    >
                      Request Quote
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quick Navigation - Fixed at Bottom */}
      <section className="py-4 bg-[#F5F5F5] fixed bottom-0 left-0 right-0 z-40 hidden lg:block border-t border-slate-200 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-6 flex-wrap">
            {services.map((service) => (
              <a
                key={service.id}
                href={`#${service.id}`}
                className="text-sm uppercase tracking-wider font-medium text-slate-600 hover:text-[#FF6B00] transition-colors"
              >
                {service.title.split(' ')[0]}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-32 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-['Barlow_Condensed'] text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-6">
            Need a Custom Solution?
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto mb-10">
            Our team of experts can design tailored engineering solutions to meet your specific requirements.
          </p>
          <Link to="/contact">
            <Button 
              data-testid="services-page-cta"
              className="bg-[#FF6B00] text-white hover:bg-[#E65000] rounded-none uppercase tracking-wider font-bold px-10 py-6 text-base btn-glow"
            >
              Contact Our Team
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
